import { CmsCta } from './CmsCta';

export { CmsBannerContainer as banner } from 'features/Banners/CmsBanner/CmsBannerContainer';
export { Collection as collection } from './Collection/Collection';
export { CmsConditionalText as conditionaltext } from './CmsConditionalText/CmsConditionalText';
export {
  ExperimentVariationContainer as experimentvariation,
} from './ExperimentVariation/ExperimentVariationContainer';
export { CmsHeading as heading } from './CmsHeading/CmsHeading';
export { HeroV2Container as hero } from './HeroV2/HeroV2Container';
export { CmsLayout as layout } from './CmsLayout/CmsLayout';
export { LeadGen as leadgen } from './LeadGen/LeadGen';
export { PlanSelectionContainer as plans } from './PlanSelection/PlanSelectionContainer';
export { CmsSection as section } from './CmsSection/CmsSection';
export { StaticModule as staticmodule } from './StaticModule/StaticModule';
export { CmsText as text } from './CmsText/CmsText';
export { Tile as tile } from './Tile/Tile';
export { UserQuoteContainer as userquote } from './UserQuote/UserQuoteContainer';
export { VisitableVenues as visitablevenues } from './VisitableVenues/VisitableVenues';

export { CitcatLinks as citcatcities } from './CitcatLinks/CitcatLinks';
export { Faq as faq } from './Faq/Faq';
export { InviteAFriendHero as inviteafriendhero } from './InviteAFriendHero/InviteAFriendHero';
export { Benefits as membershipbenefits } from './Benefits/Benefits';
export { Picture as picture } from './Picture/Picture';
export { Press as press } from './Press/Press';
export { ProductGroupContainer as productcard } from './ProductGroup/ProductGroupContainer';
export { Template as templatemodule } from './Template/Template';
export { Testimonials as testimonials } from './Testimonials/Testimonials';

// CMS CTA Types
export const calltoaction = CmsCta;
export const ctaoffercheckout = CmsCta;
export const ctareferafriend = CmsCta;
export const ctayoutubevideo = CmsCta;
export const calltoactiongeneral = CmsCta;
